if (!customElements.get('sidebar-navigation')) {
  customElements.define(
    'sidebar-navigation',
    class SidebarNavigation extends HTMLElement {
      connectedCallback() {
        this.querySelector('[data-cart-drawer-button]')?.addEventListener('click', this.openCartDrawer.bind(this));
      }

      openCartDrawer(event) {
        const cartDrawer = document.querySelector('cart-drawer');
        if (!cartDrawer) return;

        document.querySelector('[data-navigation-toggle]')?.classList.remove('activeclose');
        document.body.classList.remove('activeover', 'activeover-for');

        cartDrawer.open(event.currentTarget);
      }
    }
  );
}
